import _ from 'lodash';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import Products from './Products.js';
import DateTime from './DateTime.js';
import AuditWorkItemHelper from './AuditWorkItemHelper.js';

function updateDigitalConsent(application) {
    if (!application) return null;
    let result = _.cloneDeep(application);
    if (window.NOA.userContext.isInvestor && !application.isApplicationDataNotReadyForFunding && Products.isSuper(application.productId)) {
        // if user is an investor and he is applying for a super account that does not hit any shell account criteria in Path 2 of confluence 
        // https://confluence.prod.cba/display/FAM/Create+shell+account, digital digital consent is set to Y and we record the timestamp
        result.hasDigitalSignature = ApplicationConstants.YesNoValues.YES;
        result.DigitalSignatureTimeStamp = DateTime.getCurrentDate();

        const isFni = window.NOA.userContext.isInvestor && window.NOA.userContext.isExisting;
        const workItem = AuditWorkItemHelper.generateApplicationConsentWorkItem(isFni, result.clientIp);
        if (result.form == null) {
            result.form = {
                workItem: {
                    digitalConsentBackFile: workItem
                }
            }
        }
        else if (result.form.workItem == null) {
            result.form.workItem = {
                digitalConsentBackFile: workItem
            };
        } else {
            result.form.workItem.digitalConsentBackFile = workItem;
        }
    }
    return result;
}

const DigitalConsentHelper = {
    updateDigitalConsent:updateDigitalConsent
};

export default DigitalConsentHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/DigitalConsentHelper.js